import * as React from 'react'

/** "Invalid Entry" bubble shown for 3 s after an out-of-range value is committed. */
export function useInvalidEntryTooltip() {
  const invalidEntryTooltipTimerRef = React.useRef<ReturnType<typeof setTimeout> | null>(null)
  const [invalidEntryTooltipVisible, setInvalidEntryTooltipVisible] = React.useState(false)

  React.useEffect(() => {
    return () => {
      if (invalidEntryTooltipTimerRef.current) {
        clearTimeout(invalidEntryTooltipTimerRef.current)
      }
    }
  }, [])

  const flashInvalidEntryTooltip = React.useCallback(() => {
    if (invalidEntryTooltipTimerRef.current) {
      clearTimeout(invalidEntryTooltipTimerRef.current)
      invalidEntryTooltipTimerRef.current = null
    }

    setInvalidEntryTooltipVisible(true)
    invalidEntryTooltipTimerRef.current = setTimeout(() => {
      setInvalidEntryTooltipVisible(false)
      invalidEntryTooltipTimerRef.current = null
    }, 3000)
  }, [])

  return { invalidEntryTooltipVisible, flashInvalidEntryTooltip }
}
